module.exports = __webpack_public_path__ + "static/media/paris.733fb581.jpeg";